import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

type SkeletonLoaderProps = {
  height?: number;
  width?: number;
  containerClassName?: string;
  className?: string;
  count?: number;
};

export const SkeletonLoader = ({
  height,
  width,
  containerClassName,
  className,
  count,
}: SkeletonLoaderProps) => {
  return (
    <Skeleton
      baseColor="#121f29"
      highlightColor="#1f3347"
      width={width}
      height={height ?? 50}
      className={className}
      containerClassName={containerClassName}
      count={count}
    />
  );
};
